<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Tambah SIUPAL</h4>
          <button type="button" class="btn btn-sm" v-on:click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-if="siupalData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column100">Bidang</div>
          </div>
          <div class="horizontal" v-for="(item, index) in siupal" :key="index">
            <div class="column5">
              <input
                class="modal-input-checkbox"
                type="checkbox"
                :id="index"
                :value="item.id"
                v-model="siupal[index]['checked']"
              />
            </div>
            <div class="column100">{{ item.desc }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" v-on:click="submit()">
            Selesai
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      siupal: [],
    }
  },
  computed: {
    siupalData: async function() {
      const getSiupal = await this.$getSiupal()
      const defaultSiupal = await this.$store.state.landingpage.addedSiupal

      let reduceSiupal = await getSiupal.reduce(
        (a, b) => ({ ...a, [b.id]: b }),
        {}
      )
      let reduceDefault =
        (await defaultSiupal) &&
        defaultSiupal.reduce((a, b) => ({ ...a, [b.id]: b }), {})

      let combine = { ...reduceSiupal, ...reduceDefault }

      let newSiupal = await Object.values(combine)
      this.siupal = newSiupal.sort((a, b) => this.$sortAsc(a, b))
    },
    filteredSiupal: function() {
      const filtered =
        this.siupal && this.siupal.filter(i => i.checked && i.checked == true)
      return filtered
    },
  },
  methods: {
    async submit() {
      const filterSiupal =
        (await this.siupal) &&
        this.siupal.filter(i => i.checked && i.checked == true)
      await this.$store.commit('landingpage/SET_LANDINGPAGE_MODAL', {
        name: 'addSiupal',
        status: false,
      })
      await this.$store.commit('landingpage/SET_CHECKED', {
        name: 'addedSiupal',
        filter: filterSiupal,
      })
    },
    closeModal() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_MODAL', {
        name: 'addSiupal',
        status: false,
      })
    },
  },
}
</script>
<style scoped>
.modal {
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-dialog {
  width: 100vw;
  background-color: green;
}

.modal-content {
  width: 90vw;
  position: absolute;
  transform: translateX(-30%);
}

.modal-body {
  height: 50vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
